import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import mediaPlaceholder from "../../../Common/_assets/img/placeholder/photo-placeholder.png";

const AlbumModal = ({
	showAlbumModal,
	setShowAlbumModal,
	albumMedia,
	title,
}) => {
	useEffect(() => {
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [selectedMedia, setSelectedMedia] = useState(null);
	const [showMediaModal, setShowMediaModal] = useState(false);

	const s3Url = "https://jwlfyc-public-us-east-1.s3.amazonaws.com/";

	return (
		<>
			<Modal
				size={"xl"}
				centered
				show={showAlbumModal}
				onHide={() => {
					setShowAlbumModal(false);
				}}
			>
				<Modal.Header closeButton>
					<Modal.Title
						style={{
							justifyContent: "center",
							color: "#fff",
							fontSize: ".8em",
							textTransform: "uppercase",
							letterSpacing: ".25em",
						}}
					>
						{title}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body className={"text-center"}>
					<div className={"my-4 pb-2 row"}>
						{albumMedia
							? albumMedia.map((m, i) => (
									<div
										key={i}
										className={"col-12 col-md-4 mb-4"}
									>
										<div className={""}>
											<a
												href={"/"}
												rel="noopener noreferrer"
												className="titledetail__mediaitem d-block"
												onClick={(e) => {
													e.preventDefault();
													setSelectedMedia(
														m.filename,
													);
													setShowMediaModal(true);
												}}
											>
												<div
													className="titledetail__mediaitem--thumbnail-container"
													style={{
														backgroundImage:
															'url("' +
															s3Url +
															m.filename +
															'")',
														backgroundSize: "cover",
														backgroundPosition:
															"center center",
														backgroundRepeat:
															"no-repeat",
													}}
												>
													<img
														src={mediaPlaceholder}
														alt={m.title}
														className="titledetail__mediaitem--placeholder"
													/>
												</div>
											</a>
										</div>
									</div>
								))
							: null}
					</div>
				</Modal.Body>
			</Modal>
			<Modal
				size={"xl"}
				centered
				show={showMediaModal}
				onHide={() => {
					setShowMediaModal(false);
				}}
				className={"album-media-modal"}
			>
				<Modal.Header
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						zIndex: 1,
					}}
					closeButton
				>
					<Modal.Title></Modal.Title>
				</Modal.Header>

				<Modal.Body className={"text-center p-0"}>
					<div className={""}>
						<img
							src={s3Url + selectedMedia}
							alt={selectedMedia}
							className={"d-block"}
						/>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default AlbumModal;
